import ApiInterface from "utils/ApiInterface";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

export async function getTeamsApi(id) {
  try {
    const response = await ApiInterface.instance.getTeam(id);
    return response;
  } catch (error) {
    if (error) {
      let errorMessage = error?.response?.data?.message;
      if (!!errorMessage) {
        withReactContent(Swal).fire({
          title: "Error",
          html: errorMessage,
        });
      }
    }
  }
}
